"use client";

import React from "react";
import type { ComposeProviderStackProps } from "@/lib/core/crm/types";
import { ComposeFormStateProvider } from "./ComposeFormStateContext";
import { ComposeWatchedFieldsProvider } from "./ComposeWatchedFieldsContext";
import { ComposeRecipientsProvider } from "./ComposeRecipientsContext";
import { ComposeClientProvider } from "./ComposeClientContext";
import { ComposeEmailFormatProvider } from "./ComposeEmailFormatContext";

/**
 * `formState` and `watchedFields` are two halves of what used to be one value.
 * The split is the point: `watchedFields` changes on every keystroke and
 * `formState` must not, so a consumer subscribes to only the granularity it
 * needs. Both must be referentially stable for their own inputs — build them
 * with the hooks in `ComposeModalContextUtils`.
 */
export function ComposeProviderStack({
  children,
  formState,
  watchedFields,
  recipientsState,
  clientState,
  emailFormatState,
}: ComposeProviderStackProps) {
  return (
    <ComposeFormStateProvider value={formState}>
      <ComposeWatchedFieldsProvider value={watchedFields}>
        <ComposeRecipientsProvider value={recipientsState}>
          <ComposeClientProvider value={clientState}>
            <ComposeEmailFormatProvider value={emailFormatState}>
              {children}
            </ComposeEmailFormatProvider>
          </ComposeClientProvider>
        </ComposeRecipientsProvider>
      </ComposeWatchedFieldsProvider>
    </ComposeFormStateProvider>
  );
}
